import { LoadingButton } from '../common';
/**
 * 提交按钮
 * @param {String} text 文案
 * @param {Boolean} isLoading 是否 loading
 * @param {Boolean} disabled 是否 disabled
 * @param {Function} onClick 点击事件
 */
export const ModalContinueButton = ({
  text = 'Continue',
  isLoading = false,
  disabled = false,
  onClick,
}) => (
  <LoadingButton
    variant="outlined"
    disabled={disabled}
    loading={isLoading}
    style={{
      borderRadius: '2px',
      color: '#ffffff',
      marginLeft: '20px',
      height: '36PX',
      border: 'none',
    }}
    onClick={onClick}
  >
    {text}
  </LoadingButton>
);
